import {MutableRefObject, useRef} from "react";

export const useRefreshRef = (): RefreshableElementRef => {
    return useRef<RefreshableElement | undefined>(undefined);
};

export interface RefreshableElementProps {
    refreshRef?: RefreshableElementRef;
}

export type RefreshableElementRef = MutableRefObject<RefreshableElement | undefined>;

export interface RefreshableElement {
    refresh: () => void;
}

export const setRefreshRefValue = (
    refreshRef: RefreshableElementRef | undefined,
    refresh: () => void,
) => {
    if (refreshRef !== undefined)
        refreshRef.current = {
            refresh: refresh,
        };
};

export const useForwardedRefreshRef = (
    ref: RefreshableElementRef | undefined,
): RefreshableElementRef => {
    const newRef = useRefreshRef();
    return ref ?? newRef;
};
